import * as THREE from 'three';
import { CadObject } from '../../../models/cad-object.model';

export function renderCadObjects(
  objectGroup: THREE.Group,
  cadObjects: CadObject[],
): void {
  objectGroup.clear();
  const meshes = cadObjects
    .map((cadObject) => cadObject.mesh)
    .filter((mesh): mesh is THREE.Mesh => mesh instanceof THREE.Mesh);

  objectGroup.add(...meshes);
}
